import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Layout } from "./utility/context/Layout";
import * as serviceWorker from "./serviceWorker";
import { store } from "./redux/storeConfig/store";
import Spinner from "./components/@vuexy/spinner/Fallback-spinner";
import "./index.scss";
import "./@fake-db";
import { ToastContainer } from "react-toastify";
import CloseButton from "./common/utils/CloseButton";
import "react-toastify/dist/ReactToastify.css";

import Amplify from "aws-amplify";
import Storage from "@aws-amplify/storage";
import awsExports from "./aws-exports";
Storage.configure(awsExports);
Amplify.configure(awsExports);
// Set this to Debug Level to troubleshoot AWS Issues
// window.LOG_LEVEL = 'DEBUG';
// Amplify.Logger.LOG_LEVEL = 'DEBUG';

const LazyApp = lazy(() => import("./App"));

// configureDatabase()
ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <Layout>
        <ToastContainer closeButton={<CloseButton />} />
        <LazyApp />
      </Layout>
    </Suspense>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
